import React, {useState, useEffect} from "react";
import {createRoot} from 'react-dom/client';
import {marked} from "marked";
import gsap from "gsap";


const Chat = () => {
    const [initialPrompt, setInitialPrompt] = useState('');
    const [firstMsg, setFirstMsg] = useState('');
    const [appReady, setAppReady] = useState(false);
    const [responses, setResponses] = useState([]);
    const [message, setMessage] = useState("");

    const [tokensIn, setTokensIn] = useState(0);
    const [tokensOut, setTokensOut] = useState(0);
    const [source, setSource] = useState('');
    const [sourceTokens, setSourceTokens] = useState(0);
    const [model, setModel] = useState("gpt-4o-mini");
    const [spend, setSpend] = useState(0);
    const [loading, setLoading] = useState(false);
    const [preset, setPreset] = useState("");
    const [messages, setMessages] = useState([]);

    const [chatOpen, setChatOpen] = useState(false);

    const charactersPerToken = 4;

    let apiUrl = "https://chat.webien.io/api/chat";
    if (window.location.hostname.includes('.test')) {
        apiUrl = "http://localhost:3000/chat";
    }

    const getSpend = function () {

        if (tokensIn === 0 || tokensOut === 0) return 0;
        let currentModel = models.filter((item) => item.name === model)[0];

        // Cost is per million tokens
        let costIn = (currentModel.costIn / 1000000) * tokensIn;
        let costOut = (currentModel.costOut / 1000000) * tokensOut;

        let dollarSek = 10.2;

        //return Math.round(costIn + costOut) / 100000;
        return ((costIn + costOut) * dollarSek).toFixed(5);
    }

    async function getSourceTokens() {
        if (source === '') return 0;
        let json = await fetchJsonFromUrl(source);
        let str = JSON.stringify(json);

        setSourceTokens(prevCount => formatNumber(Math.round(str.length / charactersPerToken)));
    }


    const models = [
        {
            name: 'gpt-4-turbo',
            costIn: 10,
            costOut: 30
        },
        {
            name: 'gpt-4',
            costIn: 30,
            costOut: 60
        },
        {
            name: 'gpt-4o-mini',
            costIn: 0.15,
            costOut: 0.6
        },
        {
            name: 'gpt-3.5-turbo',
            costIn: 3.0,
            costOut: 6.0
        },
    ];

    useEffect(() => {
        setAppReady(true);
        init();
    }, []);

    useEffect(() => {
        if (source) {
            getSourceTokens();
        }
    }, [source]);


    useEffect(() => {
        if (loading) {
            scrollToBottom();
        }
    }, [loading]);

    const formatNumber = function (number) {
        return Intl.NumberFormat('sv-SE').format(number);
    }

    const init = () => {
        setInitialPrompt(webienAi.systemPrompt);
        setSource(prev => webienAi.file);
        setFirstMsg(prev => webienAi.firstMsg);
        setModel(webienAi.model);
    };



    const Loader = () => {
        return (
            <svg width="120" height="30" viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" fill="#000">
                <circle cx="15" cy="15" r="15">
                    <animate attributeName="r" from="15" to="15"
                             begin="0s" dur="0.8s"
                             values="15;9;15" calcMode="linear"
                             repeatCount="indefinite"/>
                    <animate attributeName="fill-opacity" from="1" to="1"
                             begin="0s" dur="0.8s"
                             values="1;.5;1" calcMode="linear"
                             repeatCount="indefinite"/>
                </circle>
                <circle cx="60" cy="15" r="9" fillOpacity="0.3">
                    <animate attributeName="r" from="9" to="9"
                             begin="0s" dur="0.8s"
                             values="9;15;9" calcMode="linear"
                             repeatCount="indefinite"/>
                    <animate attributeName="fill-opacity" from="0.5" to="0.5"
                             begin="0s" dur="0.8s"
                             values=".5;1;.5" calcMode="linear"
                             repeatCount="indefinite"/>
                </circle>
                <circle cx="105" cy="15" r="15">
                    <animate attributeName="r" from="15" to="15"
                             begin="0s" dur="0.8s"
                             values="15;9;15" calcMode="linear"
                             repeatCount="indefinite"/>
                    <animate attributeName="fill-opacity" from="1" to="1"
                             begin="0s" dur="0.8s"
                             values="1;.5;1" calcMode="linear"
                             repeatCount="indefinite"/>
                </circle>
            </svg>
        )
    }

    const openChat = () => {
        setChatOpen(true);
        setTimeout(() => {
            document.querySelector(".input-form input").focus();
            scrollToBottom();
        }, 100);


        // Add class to html to prevent scrolling
        document.querySelector("html").classList.add("webien-chat-open");
    }

    const closeChat = () => {
        setChatOpen(false);
        document.querySelector("html").classList.remove("webien-chat-open");
    }


    const scrollToBottom = () => {
        const chat = document.querySelector("#webien-ai .overlay");
        if (chat) {
            chat.scrollTo({
                top: chat.scrollHeight,
                behavior: "smooth",
            });
        }
    }


    const checkMessage = (e) => {
        if (e.key === "Enter") {
            sendMessageToAI();
        }
    }


    async function fetchJsonFromUrl(url) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP-fel! Status: ${response.status}`);
        return await response.json();
    }

    const sendMessageToAI = async () => {
        // Return if message is empty
        if (message === '') {
            document.querySelector(".input-form input").focus();
            return;
        }

        if (!responses.length && (source === '' || initialPrompt === '')) {
            alert("Du behöver skicka med en prompt och en json källa.");
            return;
        }

        setLoading(true);


        // if first message, add initial prompt
        if (messages.length === 0) {
            messages.push({role: "system", content: initialPrompt});
            const jsonData = await fetchJsonFromUrl(source);

            let jsonMsg = `JSON data: ` + JSON.stringify(jsonData);
            messages.push({role: "system", content: jsonMsg});
        }


        const responseIndex = responses.length;
        setResponses((prevResponses) => [...prevResponses, ""]);

        // Update tokensIn (Grov uppskattning 1 token = 4 tecken)


        // It there was an answer for last question, add it to the messages array
        if (responses.length > 0) {
            messages.push({role: "assistant", content: responses[responseIndex - 1]});
        }

        // Push this message to the messages array
        messages.push({role: "user", content: message});

        setTokensIn(prevCount => prevCount + (message.length / charactersPerToken));

        messages.forEach((msg) => {
            setTokensIn(prevCount => prevCount + (msg.content.length / charactersPerToken));
        });


        setMessage("");

        scrollToBottom();


        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": webienAi.apiKey
                },
                body: JSON.stringify({
                    initialPrompt,
                    model,
                    source,
                    messages
                }),
            });

            if (response.status === 401) {
                // Visa något i UI:t, redirect till login, etc.
                setResponses((prevResponses) => {
                    const newResponses = [...prevResponses];
                    newResponses[responseIndex] += 'Fel: API-nyckeln är ogiltig. Kontakta  en administratör.';
                    return newResponses;
                });

                setLoading(false);
                return;
            }


            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");


            const readStream = () => {
                reader.read().then(({done, value}) => {
                    if (done) return;

                    setLoading(false);

                    const chunk = decoder.decode(value, {stream: true});

                    chunk.split("\n").forEach((line) => {
                        if (line.startsWith("data: ")) {
                            const json = JSON.parse(line.substring(6));

                            if (json.hasOwnProperty('tokens_out')) {
                                setTokensOut(prevCount => prevCount + json.tokens_used);

                            } else if (json.content !== '') {

                                setResponses((prevResponses) => {
                                    const newResponses = [...prevResponses];
                                    newResponses[responseIndex] += json.content;
                                    setTokensOut(prevCount => prevCount + 1);


                                    return newResponses;
                                });

                                // Sroll inner container to bottom
                                scrollToBottom();

                            }

                        }
                    });

                    readStream();
                });


            };


            readStream();
        } catch (error) {
            console.error("Error fetching response:", error);
        }
    };

    return (
        <div>
            <button className={`openChat ${chatOpen ? "hide" : ""}`} onClick={() => openChat()}>
                <i className="icon icon-chat2"></i>
            </button>

            <div className={`overlay ${chatOpen ? "active" : ""}`}>

                <div className="header">
                    {(() => {
                        if (!webienAi.showInfo) return null;

                        return (
                            <div className="info">
                                <div className="spend">
                                    <div className="txt"><b>{getSpend()}:-</b> Tokens: {formatNumber(tokensIn)} in
                                        | {formatNumber(tokensOut)} ut</div>
                                </div>
                            </div>
                        );
                    })()}


                    <button className="closeChat" onClick={() => closeChat()}>
                        <i className="icon icon-close"></i>
                    </button>
                </div>


                <div className="conversation">
                    <div className="assistant first-msg">
                        <div className="avatar"><i className="icon icon-assistant"></i></div>
                        <div className="msg" dangerouslySetInnerHTML={{__html: marked(firstMsg)}}/>
                    </div>

                    {messages.map((msg, index) => {
                        if (msg.role === "assistant") {
                            return (
                                <div className="assistant" key={index}>
                                    <div className="avatar">
                                        <i className="icon icon-assistant"></i>
                                    </div>
                                    <div
                                        className="msg"
                                        dangerouslySetInnerHTML={{ __html: marked(msg.content) }}
                                    />
                                </div>
                            );
                        } else if (msg.role === "user") {
                            return (
                                <div
                                    className="user"
                                    key={index}
                                    dangerouslySetInnerHTML={{ __html: msg.content }}
                                />
                            );
                        } else {
                            return null;
                        }
                    })}


                    {(() => {
                        const lastResponse = responses[responses.length - 1];
                        if (!lastResponse) return null;

                        return (
                            <div className="assistant">
                                <div className="avatar"><i className="icon icon-assistant"></i></div>
                                <div className="msg" dangerouslySetInnerHTML={{ __html: marked(lastResponse) }}/>
                            </div>
                        );
                    })()}

                    {(() => {
                        if (!loading) return null;

                        return (
                            <div className="assistant loading">
                                <div className="avatar"><i className="icon icon-assistant"></i></div>
                                <div className="loader">
                                    <Loader/>
                                </div>
                            </div>
                        );
                    })()}

                </div>


                <div className="input-form">
                    <input
                        type="text"
                        value={message}
                        onKeyDown={(e) => {checkMessage(e)}}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Skriv din fråga här..."
                    />
                    <button onClick={sendMessageToAI}><i className="icon icon-up"></i></button>
                </div>

            </div>
        </div>


    );
};

if (document.getElementById("webien-ai")) {
    const root = createRoot(document.getElementById('webien-ai'));
    root.render(<Chat/>);
}

export default Chat;